import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'


export const state = {
  bayData: {},
}

export const mutations = {
  SET_BAY_DATA(state, payload) {
    Vue.set(state.bayData, payload.flightId, payload.data)
  },
}

export const getters = {
  getBayDataByFltId: (state, getters, rootState) => (flightId) => {
    console.log(rootState, rootState.flights.selectedFlightId)
    return state.bayData[rootState.flights.selectedFlightId]
  },
}

export const actions = {
  GET_BAY_DATA({ commit, dispatch, getters }, flightId) {

    axios
      .get(`${window.config.apiBaseUrl}bays/flightid/${flightId}`)
      .then((response) => {
        const data = response.data.Results[0]
        const payload = {
          flightId: flightId,
          data: data,
        }
        commit('SET_BAY_DATA', payload)
      })
      .catch((error) => {
        console.log(error)
      })
  },
}
